module.exports = __webpack_public_path__ + "static/img/sy.766197b3.svg";